import { NumberInput, required } from "react-admin";
import { OperationalPowerFields } from "../shared/initialFields";

const TestFcrNInitialFields = () => {
  return (
    <>
      <NumberInput source={OperationalPowerFields.minimalOperationalPower} defaultValue={0.1} validate={[required()]} />
      <NumberInput
        source={OperationalPowerFields.maximalOperationalPower}
        defaultValue={0.927}
        validate={[required()]}
      />
    </>
  );
};

export default TestFcrNInitialFields;
